import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initSentry, installConsoleCapture, SentryErrorBoundary } from './sentry';

initSentry();
installConsoleCapture();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={<div className="app-error-boundary">Something went wrong.</div>}>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>
);
